import { render, staticRenderFns } from "./CreateMerchant.vue?vue&type=template&id=a69cfea4&scoped=true&"
import script from "./CreateMerchant.vue?vue&type=script&lang=js&"
export * from "./CreateMerchant.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchant.vue?vue&type=style&index=0&id=a69cfea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69cfea4",
  null
  
)

export default component.exports